import { useContext } from 'react';

import SessionContext, { SessionContextValues } from './context';

const useSession = (): SessionContextValues => useContext(SessionContext);

export default useSession;
